import React, { useEffect, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { TextField } from "@mui/material";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { SFHabitacionCambioDo } from "services/services-mia/SFHabitacionCambioDo";
import { SFHabitacionGet } from "services/services-mia/SFHabitacionGet";

export default function CambioHabitacionModal({
    reserva,
    hotelId,
    updateList,
    closeModal,
    setterRowSelected,
}) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const [habitaciones, setHabitaciones] = useState([]);
    const [selectedHabitacionId, setSelectedHabitacionId] = useState("");
    const [hasChange, setHasChange] = useState(true);

    useEffect(() => {
        if (!hotelId) return;
        (async () => {
            const result = await SFHabitacionGet(credentials, {
                SFHotelId: Number(hotelId),
                SFHabitacionStatus: "D",
            });
            if (Array.isArray(result) && result[0]?.SFHabitacionId) {
                const disponibles = result.filter(
                    (h) => h.SFHabitacionId !== reserva?.SFHabitacionId
                );
                setHabitaciones(disponibles);
            }
        })();
    }, [credentials, hotelId, reserva?.SFHabitacionId]);

    const handleChange = async () => {
        const SFHabitacionHuespedId = reserva?.SFHabitacionHuespedId ?? reserva?.id;
        if (!SFHabitacionHuespedId || !selectedHabitacionId) {
            setHasChange(false);
            return;
        }
        setInRequest(true);
        const response = await SFHabitacionCambioDo(credentials, {
            SFHabitacionHuespedId,
            SFHabitacionId: Number(selectedHabitacionId),
        });
        setInRequest(false);
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Habitación cambiada correctamente",
                severity: "success",
                open: true,
            });
            updateList();
            setterRowSelected({ status: false, row: {} });
            closeModal();
        }
    };

    const handleHasChange = (e) => {
        setSelectedHabitacionId(e);
        e.value === '' ? setHasChange(false) : setHasChange(true);
    }

    return (
        <div className={styles.inputs}>
            <div className={styles["column-2"]}>
                <div className={styles["span-2"]}>
                    <TextField
                        fullWidth
                        label="Nueva habitación"
                        margin="dense"
                        select
                        SelectProps={{ native: true }}
                        value={selectedHabitacionId}
                        variant="standard"
                        onChange={(event) => handleHasChange(event.target.value)}
                        InputLabelProps={{
                            style: { fontSize: "1.3rem" },
                            shrink: true,
                        }}
                    >
                        <option value="">Seleccionar habitación</option>
                        {habitaciones.map((h) => (
                            <option key={h.SFHabitacionId} value={h.SFHabitacionId}>
                                {`Hab. ${h.SFHabitacionNumero} - Piso ${h.SFHabitacionPiso}`}
                            </option>
                        ))}
                    </TextField>
                    {
                        !hasChange && (
                            <small style={{ color: "red", fontWeight: "500", marginTop: "0.5rem" }}>
                                Selecciona una habitación 
                            </small>
                        )
                    }
                </div>
                <div className={styles.actions}>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Cambiar" }}
                        onClick={handleChange}
                        onCloseModal={closeModal}
                        disabled={inRequest}
                        ignoreSnackbar
                    />
                    {inRequest && <CircularIndeterminate />}
                </div>
            </div>
        </div>
    );
}
